import {Sequence} from 'components/Sequence';
import {PolymerTabState} from 'molbio/tabstates/PolymerTabState';
import {TabStateDefaults} from 'Navigation';

class NucleotidesTabState extends PolymerTabState<Sequence> {
  defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      closeable: false,
      preferenceKey: 'nucleotides',
      title: 'Nucleotides',
    };
  }
}

export default NucleotidesTabState;
